export const LEAD_STATUSES = ["New Lead", "Reviewing Photos", "Contacted", "Consultation Scheduled", "Consultation Completed",
  "Quote Created", "Quote Sent", "Won", "Lost"];

export const QUALIFICATIONS = ["Pending Review", "Revival Candidate", "Potential Restoration Lead", "Not Suitable"];

export const STATUS_STYLES = {
  "New Lead": "bg-[#c19a6b] text-white",
  "Reviewing Photos": "bg-amber-50 text-amber-700",
  Contacted: "bg-blue-50 text-blue-700",
  "Consultation Scheduled": "bg-indigo-50 text-indigo-700",
  "Consultation Completed": "bg-indigo-100 text-indigo-800",
  "Quote Created": "bg-[#c19a6b]/15 text-[#8a6a42]",
  "Quote Sent": "bg-[#c19a6b]/25 text-[#6d5233]",
  Won: "bg-emerald-600 text-white",
  Lost: "bg-gray-200 text-gray-500",
};

export const QUAL_STYLES = {
  "Pending Review": "border border-gray-300 text-gray-600",
  "Revival Candidate": "border border-emerald-500 text-emerald-700",
  "Potential Restoration Lead": "border border-amber-500 text-amber-700",
  "Not Suitable": "border border-red-400 text-red-600",
};

export const Badge = ({ value, styles, testId }) => (
  <span data-testid={testId} className={`inline-block text-[11px] px-2 py-1 font-semibold tracking-wide whitespace-nowrap ${styles[value] || "bg-gray-100 text-gray-600"}`}>
    {value}
  </span>
);

export const leadName = (l) => `${l.customer?.first_name || ""} ${l.customer?.last_name || ""}`.trim();

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("en-CA", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—";
